/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const AssignmentIPRangeParser = /* #__PURE__ */ parsers.object([
    ['ipRange', codecString, 'ip_range'],
]);
export class AssignmentIPRange extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return AssignmentIPRangeParser.decode(input).map(res => new AssignmentIPRange(res));
    }
    static unsafeDecode(input) {
        return AssignmentIPRange.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AssignmentIPRangeParser.encode(data);
    }
    static schema() {
        return AssignmentIPRangeParser.schema();
    }
}
